module.exports = __webpack_public_path__ + "static/media/icon_wallet.ae9e374e.svg";